<template>
  <el-dialog title="" v-model="value" size="tiny" custom-class="all-embassy-holiday-pop" :show-close="false" top="50%" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="close-box" @click="closePop()">
      <img src="https://o.666visa.cn/static/ssqpeer/homepage/icon-close-background-black.png" />
    </div>
    <div class="QR-boxcode-box">
      <img :src="qrcodeUrl"/>
      <div>微信扫码</div>
      <span>一键分享给顾客</span>
    </div>
    <div class="title-box">
      最近可预约日期<span>Appointment</span>
    </div>
    <div class="content-box">
      <el-select class="select-box" v-model="embassyCity" @change="changeEmbassyCity()">
        <el-option v-for="(v,index) in embassy_district_desc" :label="'使馆城市-' + v" :key="index" :value="index">
          <span>{{ v }}</span>
        </el-option>
      </el-select>
      <img class="select-icon" src="https://o.666visa.cn/static/ssqpeer/homepage/icon-map-red-2x.png" />

      <div class="tips">
        *可预约时间仅供参考，详情请咨询签证专家
      </div>
      <div class="content" :class="{'no-background': visa_appointment.length > 4}">
        <div class="title">
          <div class="title-country">国家</div>
          <div class="title-appointment-time">预约时间</div>
          <div class="title-update-time">更新时间</div>
        </div>

        <div class="item-box" v-if="visa_appointment.length > 0">
          <template v-for="(v, ind) in visa_appointment" >
            <div class="item" :key="ind">
              <div class="name-box">
                <img :src="v.national_flag_img" alt="">
                <span>{{v.country}}</span>
              </div>
              <div class="appointment-time">{{formatDateWithzeroWithWeek(v.earliest_date)}}</div>
              <div class="update-time">{{formatDateWithoutYear(v.update_date)}}</div>
            </div>
          </template>
        </div>

        <div class="no-data" v-if="visa_appointment.length === 0">
          <img src="https://o.666visa.cn/static/ssqpeer/homepage/country-no-data-2x.png" alt="">
          <p>抱歉！暂无信息</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dateUtils from '../../../libs/date-util';
import Http from '../../../libs/http';

export default {
  name: 'earlist-date-pop',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      qrcodeUrl: '',
      visa_appointment: [],
      embassyCity: '', // 下拉框选择的城市数据
      embassy_district_desc: {},
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.getQrcode();
        this.getData();
      }
    },
  },
  created() {
  },
  methods: {
    formatDateWithoutYear: dateUtils.formatDateWithoutYear,
    formatDateWithWeek: dateUtils.formatDateWithWeek,
    formatDateWithzeroWithWeek: dateUtils.formatDateWithzeroWithWeek,

    // 关闭
    closePop() {
      this.$emit('input', false);
    },

    // 获取二维码
    getQrcode() {
      const postData = {
        page: 'subpackage/pages/earliest-date/earliest-date',
        size: 300,
        scene: `c=${this.embassyCity}`,
      };

      Http.post('/sys/qrcode_get', postData).then((data) => {
        this.qrcodeUrl = `data:image/jpeg;base64,${data.qrcode}`;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取数据
    getData(selectCityID) {
      const params = {};
      if (selectCityID) {
        params.city_id = selectCityID;
      }
      return Http.post('/sys/visa_appointment_query', params).then((data) => {
        this.visa_appointment = data.visa_appointment;
        this.embassy_district_desc = data.embassy_district_desc;
        delete this.embassy_district_desc['0'];
        if (!selectCityID) {
          this.embassyCity = `${data.city_id}`;
        }
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 切换下拉框城市
    changeEmbassyCity() {
      const selectCityID = +this.embassyCity;
      this.getData(selectCityID);
      this.getQrcode();
    },

  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
/deep/ .all-embassy-holiday-pop{
  width: 680px;
  height: 560px;
  transform: translate(-50%,-50%);
  box-shadow: 0px 8px 12px 0px rgba(57,61,70,0.06);
  border-radius: 4px;
  margin: 0;
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
  }
  .close-box {
    position: absolute;
    top: 0;
    right: -72px;
    border-radius: 1px;
    img {
      width: 52px;
      height: 52px;
    }
  }
  .QR-boxcode-box {
    position: absolute;
    bottom: 0;
    left: 100%;
    margin-left: 20px;
    padding: 12px;
    background: linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,255,1) 100%);
    box-shadow: 6px 0px 20px 0px rgba(47,51,61,0.08);
    border-radius: 4px;
    display: flex;
    flex-flow: column;
    align-items: center;
    img {
      width: 150px;
      height: 150px;
      margin-top: 12px;
    }
    div {
      color: #599FFF;
      font-size: 16px;
      font-weight: bold;
      margin: 8px 0;
    }
    span {
      color: #2F333D;
      font-size: 12px;
    }
  }
  .title-box {
    background: rgba(243,118,107,1);
    border-radius: 4px 4px 0px 0px;
    padding: 24px 0 44px 32px;
    color: #FFFFFF;
    font-size: 24px;
    font-weight: bold;
    span {
      font-size: 20px;
      color:rgba(255,255,255,0.4);
      margin-left: 8px;
    }
  }
  .content-box {
    padding: 38px 32px 32px 32px;
    position: relative;
    .select-box {
      position: absolute;
      top: -20px;
      left: 32px;
      width: 152px;
      height: 40px;
      background:rgba(255,255,255,1);
      box-shadow: 0px 12px 20px -10px rgba(255,100,100,0.3);
      border-radius: 2px;
      .el-input {
        height: 100%;
        .el-input__icon {
          color: rgba(243,118,107,1)!important;
          width: 28px;
          transform: translateY(-50%) rotateZ(180deg) scale(0.7);
          transform-origin: center center;
          &.is-reverse{
            transform: translateY(-50%) scale(0.7);
          }
        }
        .el-input__inner {
          height: 100%;
          color: rgba(243,118,107,1);
          font-size: 14px;
          padding-left: 32px;
          padding-right: 28px;
        }
      }
      input {
        border: none;
      }
    }
    .select-icon {
      position: absolute;
      top: -11px;
      left: 42px;
      width: 20px;
      height: 20px;
    }
    .tips {
      margin-bottom: 12px;
      color: #91999F;
    }
    .content {
      width: 100%;
      border: 1px solid rgba(233,238,242,1);
      background: url(https://o.666visa.cn/static/ssqpeer/homepage/country-background-default-2x.png) no-repeat center bottom / 616px 120px;
      &.no-background {
        background: none;
      }
      .title {
        height: 46px;
        background:rgba(243,246,249,1);
        display: flex;
        align-items: center;
        padding-left: 20px;
        color: #5F666E;
        font-size: 16px;
        line-height: 1;
        .title-country {
          width: 172px;
        }
        .title-appointment-time {
          width: 264px;
        }
      }
      .item-box {
        height: 351px;
        overflow-y: auto;
        .item {
          &:nth-child(odd) {
            background-color: #ffffff;
          }
          &:nth-child(even) {
            background-color: #FAFBFC;
          }
          display: flex;
          align-items: center;
          padding: 16px 0 16px 20px;
          color: #2F333D;
          font-size: 16px;
          line-height: 1;
          .name-box {
            display: flex;
            align-items: center;
            width: 172px;
            img {
              width: 32px;
              height: 22px;
              margin-right: 8px;
              flex-shrink: 0;
              border-radius: 2px;
            }
            span {
              width: 0;
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .appointment-time {
            width: 264px;
          }
        }
      }
      .no-data {
        display: flex;
        flex-flow: column;
        align-items: center;
        height: 351px;
        img {
          width: 140px;
          height: 90px;
          margin-top: 40px;
        }
        p {
          color: #91999F;
          font-size: 14px;
          line-height: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/earlist-date-pop.vue